module.exports = __webpack_public_path__ + "static/facebook-shops-shipkoo-80896243fa7aea9a2dc5552113998871.png";